import { getAccessToken } from '../AiAssistant/chatApiBase'

export function getEvalBase(): string {
  const env = window.env as any
  const apiEndpoint: string = env?.API_ENDPOINT ?? ''

  // Derive eval API URL from main API URL
  // http://localhost:52189/api → http://localhost:8002
  // https://api-staging.synkedup.com/api → https://eval-api-staging.synkedup.com
  // https://api.synkedup.com/api → https://eval-api.synkedup.com
  try {
    const url = new URL(apiEndpoint)
    if (url.hostname === 'localhost') {
      url.port = '8002'
    } else {
      url.hostname = url.hostname.replace(/^api/, 'eval-api')
    }
    url.pathname = ''
    return url.toString().replace(/\/$/, '')
  } catch {
    return apiEndpoint.replace(/\/api\/?$/, '')
  }
}

export function evalAuthHeaders(): Record<string, string> {
  const token = getAccessToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}
